module.exports = __webpack_public_path__ + "1c26934e1a35e375d8f9090f4d20d8b4.svg";